<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>
                <v-col class="text-left">
                    <v-btn-toggle v-model="selectedChart" shaped mandatory>
                        <v-btn value="chartone">
                            {{ $t('ChartOne') }}
                        </v-btn>
                        <v-btn value="charttwo">
                            {{ $t('ChartTwo') }}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>

            <v-dialog v-model="dialog" persistent max-width="100vw">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="2" v-for="(color, index) in sharedColors" :key="'color-picker-' + index">
                                <v-color-picker v-model="sharedColors[index]" mode="hexa"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-text>

        <v-card-text v-if="selectedChart === 'chartone'" class="align-center text-center" style=" font-size: 20px;">
            <template>
                <v-container>
                    <v-row v-for="(item, rowIndex) in value" :key="'row-' + rowIndex" class="align-center mb-5">
                        <v-col cols="7" class="text-right" style="color: #000;">
                            {{ item.name }}
                        </v-col>
                        <v-col cols="4">
                            <v-row dense>
                                <v-col v-for="(percentage, idx) in item.table"
                                       :key="'cell-' + rowIndex + '-' + idx"
                                       :style="{ backgroundColor: sharedColors[idx] }"
                                       class="pa-2 text-center white--text">
                                    {{ percentage.percentage }}%
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="1" class="text-center">
                            <v-progress-circular :value="item.percentage" size="50" width="6" color="teal">
                                {{ item.percentage }}%
                            </v-progress-circular>
                        </v-col>
                    </v-row>

                    <v-row class="mt-5 align-end" style="margin-right: 50%;">
                        <v-col cols="12">
                            <div class="text-center">
                                <v-chip v-for="(label, idx) in legend"
                                        :key="idx"
                                        class="ma-1 white--text"
                                        :color="sharedColors[idx]">
                                    {{ label.text }}
                                </v-chip>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </v-card-text>

        <v-card-text v-if="selectedChart === 'charttwo'">
            <template>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="6" lg="4" v-for="(chart, index) in value" :key="index">
                            <v-card outlined class="pa-4 text-center">
                                <div class="mb-3">{{ chart.name }}</div>
                                <canvas :id="'chart-' + index" style="max-width: 200px; margin: auto"></canvas>
                                <v-row class="mt-3">
                                    <v-col cols="auto" v-for="(label, idx) in chart.table" :key="idx" class="d-flex align-center">
                                        <v-icon :color="sharedColors[idx]" small class="mr-2">mdi-circle</v-icon>
                                        <span>{{ label.level }}</span>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
    import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'

    export default {
        props: {
            value: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                selectedChart: 'chartone', // Default to horizontal view
                sharedColors: ['#14573a', '#1b8354', '#fec84b', '#f04438','#b42318'], // Default shared colors
                legend: [

                    { text: this.$t('VerySatisfied'), color: '#14573a' },
                    { text: this.$t('Satisfied'), color: '#1b8354' },
                    { text: this.$t('Neutral'), color: '#fec84b' },
                    { text: this.$t('Dissatisfied'), color: '#f04438' },
                    { text: this.$t('VeryDissatisfied'), color: '#b42318' },
                ],
                dialog: false
            }
        },
        watch: {
            sharedColors: {
                handler(newColors) {
                    this.value.forEach(row => {
                        row.table.forEach((item, index) => {
                            item.color = newColors[index]
                        })
                    })
                },
                deep: true
            }
        },
        mounted() {
            Chart.register(ArcElement, Tooltip, Legend)
            this.$nextTick(() => {
                this.createDoughnutCharts()
            })
        },
        methods: {
            createDoughnutCharts() {
                this.value.forEach((chart, index) => {
                    const ctx = document.getElementById(`chart-${index}`).getContext('2d')
                    new Chart(ctx, {
                        type: 'doughnut',
                        data: {
                            labels: chart.table.map(item => item.level),
                            datasets: [
                                {
                                    data: chart.table.map(item => item.percentage),
                                    backgroundColor: this.sharedColors
                                }
                            ]
                        },
                        options: {
                            responsive: true,
                            plugins: {
                                legend: {
                                    display: false
                                }
                            }
                        }
                    })
                })
            }
        },
        updated() {
            this.createDoughnutCharts()
        }
    }
</script>

<style scoped>
    .pa-2 {
        padding: 10px
    }

    .text-right {
        text-align: right
    }

    .text-center {
        text-align: center
    }
</style>
